import { put, takeLatest, call, spawn, all } from 'redux-saga/effects';
import { surveyActions } from '../../../application/actions/survey';
import { loadingActions } from '../../../application/actions/ui_loaders';

import api from '../../api';

const apiSurvey = api(process.env.REACT_APP_SURVEY_API);

export function* registerResponses(action) {
  try {
    yield put(loadingActions.changeStatusLoadingRegisterSurvey({ isLoading: true }));

    const { data, error } = yield call(apiSurvey.post, 'v1/registrar', action.payload);

    if (data)
      yield all([
        put(surveyActions.registerResponsesSuccess(data)),
        put(loadingActions.changeStatusLoadingRegisterSurvey({ isLoading: false })),
      ]);
    else
      yield all([
        put(surveyActions.registerResponsesError(error)),
        put(loadingActions.changeStatusLoadingRegisterSurvey({ isLoading: false })),
      ]);
  } catch (err) {
     /* istanbul ignore next */
    yield all([
      put(surveyActions.registerResponsesError({ code: 500, message: err })),
      put(loadingActions.changeStatusLoadingRegisterSurvey({ isLoading: false })),
    ]);
  }
}

export function* watchRegisterResponses() {
  yield takeLatest(surveyActions.registerResponses.type, registerResponses);
}
 /* istanbul ignore next */
export default function* surveySaga() {
  yield spawn(watchRegisterResponses);
}
